export default __webpack_public_path__ + "static/media/renfield-visions-of-madness.e19d9033.jpg";